module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.bb47d8e5.svg";